export default __webpack_public_path__ + "static/media/Hair_18_F_C1.d5da5a51.svg";